module.exports = __webpack_public_path__ + "img/pic_jindutiao_1.47263031.png";